export const pageTypeV7 = {
  subpages: "GP_STATIC",
  productpages: "GP_PRODUCT",
  homepages: "GP_INDEX",
  collectionpages: "GP_COLLECTION",
  articlepages: "GP_ARTICLE",
}
